
  import React from "react"
  import Component from "/home/ws/spaceland/flucht.bundfuerbildung.de/site/src/layouts/index.js"
  import data from "/home/ws/spaceland/flucht.bundfuerbildung.de/site/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js